import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { NEWS } from '../data/mock';

export default function News() {
  return (
    <section id="news" className="relative py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#E85A18]">
              Newsroom
            </span>
            <h2
              className="mt-3 text-[36px] sm:text-[42px] lg:text-[48px] leading-[1.05] tracking-[-0.025em] text-[#0F1B2D] font-semibold max-w-2xl"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Latest from the Mednosys network.
            </h2>
          </div>
          <a
            href="#contact"
            className="self-start md:self-end inline-flex items-center gap-2 text-[14px] font-medium text-[#E85A18] hover:text-[#B54A15]"
          >
            View all updates <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {NEWS.map((n) => (
            <article
              key={n.title}
              className="group rounded-2xl overflow-hidden bg-white border border-slate-200/80 hover:border-orange-200 hover:shadow-[0_25px_60px_-30px_rgba(232,90,24,0.3)] transition-all duration-500"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F1B2D]/40 via-transparent to-[#FF7A2E]/10 mix-blend-multiply" />
                <div className="absolute top-4 left-4 inline-flex items-center rounded-full bg-white/95 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-[0.18em] font-semibold text-[#E85A18]">
                  {n.tag}
                </div>
              </div>
              <div className="p-6">
                <div className="text-[12px] uppercase tracking-[0.14em] text-slate-500">{n.date}</div>
                <h3
                  className="mt-2 text-[19px] leading-snug font-semibold text-[#0F1B2D] group-hover:text-[#E85A18] transition-colors"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {n.title}
                </h3>
                <p className="mt-3 text-[14px] leading-[1.65] text-slate-600">{n.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
